module.exports = __webpack_public_path__ + "static/media/afl_50_banner.c4bbf08a.png";